// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__16kFl","search":"Settings_search__26oZa","filter":"Settings_filter__2a_9A"};